import React, { ReactNode } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Layout } from 'antd'
import LanguageIcon from 'assets/images/menu-language.svg'
import { withRouter } from 'router'
import classNames from 'classnames'
import LanguageSwitcher from 'components/cleanui/layout/TopBar/LanguageSwitcher'
import { bypassPaths } from '../index'

import logoSVG from 'assets/images/logo/logo-151x40.svg'

import styles from './style.module.scss'

interface RootState {
  appsettings: {
    logo: string
  }
}

const mapStateToProps = (state: RootState) => ({
  logo: state.appsettings.logo,
})

const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface AuthLayoutProps extends PropsFromRedux {
  children: ReactNode
}

const AuthLayout = ({ children }: AuthLayoutProps): React.ReactElement => {
  const curPath = window.location.pathname
  const isBypass = bypassPaths.indexOf(curPath) > -1
  return (
    <Layout>
      <Layout.Content>
        {/* <Suspense fallback={<Spin indicator={<Loading3QuartersOutlined spin />} />}>
          <Sidebar />
        </Suspense> */}
        {/* <SupportChat /> */}
        <div className={classNames('auth-scope', `${styles.container}`)}>
          {/* <div className={classNames(`${styles.topbar}`)}>
            <div className={styles.logoContainer}>
              <a className={styles.logo} href="/">
                <img src={logoSVG} className={styles.logoImg} alt={logo} />
                <div className={styles.name}>{logo}</div>
                {logo === 'Clean UI Pro' && <div className={styles.descr}>React</div>}
              </a>
            </div>
            {/*
            <div className="d-none d-sm-block">
              <span className="mr-2">Don&#39;t have an account?</span>
              <Link to="/auth/register" className="font-size-16 kit__utils__link">
                Sign up
              </Link>
            </div>
            */}
          {/* <div className="mr-4 d-none d-sm-block">
              <div className="menu-language">
                <GlobalOutlined className="mr-2" />
                <span className="label">{t('topBar.profileMenu.language')} : </span>
              </div>
            </div>
          </div>  */}
          <div className={styles.containerInner}>
            {isBypass === false && (
              <div className={styles.topArea}>
                <img src={logoSVG} alt="logo" />
                <div className={styles.languageSwitcher}>
                  <img src={LanguageIcon} alt="language" className="mr-2" />
                  <LanguageSwitcher />
                </div>
              </div>
            )}

            {children}
          </div>
          {/* <div className={classNames(styles.footer, 'pb-5', 'pt-5')}> */}
          {/*
            <ul
              className={`${styles.footerNav} list-unstyled d-flex mb-0 flex-wrap justify-content-center`}
            >
              <li>
                <a href="#" onClick={e => e.preventDefault()}>
                  Terms of Use
                </a>
              </li>
              <li>
                <a href="#" onClick={e => e.preventDefault()}>
                  Compliance
                </a>
              </li>
              <li>
                <a href="#" onClick={e => e.preventDefault()}>
                  Support
                </a>
              </li>
              <li>
                <a href="#" onClick={e => e.preventDefault()}>
                  Contacts
                </a>
              </li>
            </ul>
            */}
          {/*
            <div className="text-center">
              ⓒ 2025 NextIntelligence.ai |{' '}
              <a
                href="https://www.9folders.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
            */}
          {/* </div> */}
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connector(AuthLayout))
